export default __webpack_public_path__ + "static/justPremium-8ddb21945a71e068fc8ab550936108f0.svg";